export * from './badge-status-fila-integracao.pipe';
